// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/buy/masterpass-info-dialog/masterpass-info-dialog.less
// module id = 558
// module chunks = 0